export default class ProductsStats {
	countriesCount: number;

	constructor(countriesCount: number) {
		this.countriesCount = countriesCount;
	}
}
